import { cx } from "shared/utils";
import { Check, XClose } from "untitledui-js-base";

export const CheckmarkChime = ({ isSuccess }: { isSuccess: boolean }) => (
  <div
    className={cx(
      "h-10 w-10  shrink-0 rounded-full relative border flex items-center justify-center border-alpha-100",
      isSuccess ? "bg-success-50" : "bg-danger-50"
    )}
  >
    <div
      className={cx(
        "h-[18px] flex items-center justify-center w-[18px] border border-white rounded-full -left-1 -top-1",
        isSuccess ? "bg-success-600" : "bg-danger-600"
      )}
    >
      {isSuccess ? (
        <Check size="10px" className="stroke-white stroke-[2px]" />
      ) : (
        <XClose size="10px" className="stroke-white stroke-[2px]" />
      )}
    </div>
  </div>
);
